export const environment = {
  production: true,
  pick_socket: 'wss://www.thunderhopper.com/hopper_socket',
  userInfoApiUrl : 'https://www.thunderhopper.com/api/ticketholder',
  baseApi: 'https://www.thunderhopper.com/api/',
  admin_users: ["Bradley", "Jeaux","Chris"]
};
